import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Apollo from './Apollo';
import App from 'App';
import { GlobalDebug } from 'utils/remove-console';

const basename = process.env.REACT_APP_BASENAME || '/ltcpms';
const defaultTitle = process.env.REACT_APP_TITLE || 'PolyU PMS';

const AppWrapper = () => {
  useEffect(() => {
    console.info('version', process.env.REACT_APP_VERSION);
    if (
      process.env.REACT_APP_DEBUG === 'false' &&
      process.env.REACT_APP_ENV !== 'DEVELOPMENT'
    ) {
      GlobalDebug(false, true);
    }
  }, []);

  return (
    <Router basename={basename}>
      <Apollo>
        <Helmet
          defaultTitle={defaultTitle}
          titleTemplate={`${defaultTitle} - %s"`}
        >
          <meta name="description" content="App Description" />
        </Helmet>
        <App />
      </Apollo>
    </Router>
  );
};

export default AppWrapper;
